var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7438 13.2584L13.2585 21.7437C12.9686 22.0336 12.4877 22.0336 12.1978 21.7437C11.9079 21.4538 11.9079 20.973 12.1978 20.683L20.6831 12.1978C20.973 11.9079 21.4538 11.9079 21.7438 12.1978C22.0337 12.4877 22.0337 12.9685 21.7438 13.2584Z",
    fill: "#1C1F1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.7438 21.7436C21.4538 22.0336 20.973 22.0336 20.6831 21.7436L12.1978 13.2584C11.9079 12.9684 11.9079 12.4876 12.1978 12.1977C12.4877 11.9078 12.9686 11.9078 13.2585 12.1977L21.7438 20.683C22.0337 20.9729 22.0337 21.4537 21.7438 21.7436Z",
    fill: "#1C1F1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.d9e84feb5da76f5e4abf7bfb0501f01a.svg";
export { ForwardRef as ReactComponent };